import { Store } from '../hooks/types'

export const getStoreDisplayName = (city: string) => {
  switch (city) {
    case 'Abingdon': {
      return 'Oxford | cinchServicing'
    }
    case 'Hook': {
      return 'Hampshire | cinchServicing'
    }
    case 'Leicester South': {
      return 'Leicester | cinchServicing'
    }
    case 'Cowley': {
      return 'Oxford | cinchServicing'
    }
    case 'Crawley': {
      return 'Gatwick | cinchServicing'
    }
    case 'Gillingham': {
      return 'Medway | cinchServicing'
    }
    case 'Kent': {
      return 'Canterbury | cinchServicing'
    }
    case 'Staverton': {
      return 'Cheltenham | cinchServicing'
    }
    case '': {
      return 'cinchServicing'
    }
    default: {
      return `${city} | cinchServicing`
    }
  }
}

const formatName = (name: string) => {
  const lowerCaseName = name.toLowerCase()
  if (lowerCaseName.includes('manchester')) return 'cinch OMODA & JAECOO'
  if (lowerCaseName.includes('land rover')) return 'Marshall Land Rover'
  if (lowerCaseName.includes('omoda')) return 'Marshall OMODA & JAECOO'
  if (lowerCaseName.includes('audi')) return 'Audi'
  if (lowerCaseName.includes('cinch birmingham')) return 'cinch'

  return name.split(' ').slice(0, 2).join(' ')
}

export const formatAddress = (store: Store) => {
  const county = store.town !== store.county && store.county ? store.county : ''

  return [
    formatName(store.name),
    store.addressLine1,
    store.town,
    county,
    store.postcode,
  ]
    .filter(Boolean)
    .join(', ')
}
